import { render } from "./OverviewOpportunity.vue?vue&type=template&id=4f48dab3"
import script from "./OverviewOpportunity.vue?vue&type=script&lang=js"
export * from "./OverviewOpportunity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__